const empty = {
  presence: {
    allowEmpty: false,
    message: 'require'
  }
}
const Constraints = {
  airportId: empty,
  terminalId: empty,
}

const table = {
  parkingBayNameEN: empty,
  parkingBayNameTH: empty,
}

module.exports = {
  Constraints,
  table
}